// import { ColumnDef } from "@tanstack/react-table";
import { MRT_ColumnDef } from "material-react-table";
import { TrainingType } from "../types/training";
import { getTotalTime, getTranslatedPeriod } from "../utils/periodUtils";
import { translator } from "../utils/translator";
import { ColumnDef } from "@tanstack/react-table";
import type { Course, Student } from "../types/user";
import "./tableDef.scss";

const basicTrainingTableDef: MRT_ColumnDef<TrainingType, any>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "department",
    header: "구분",
    Cell: ({ cell }) => translator[cell.getValue()],
  },
  {
    accessorKey: "course",
    header: "과정",
    Cell: ({ cell }) => {
      const translated = cell
        .getValue<Course[]>()
        .map((course) => translator[course].replace("과정", ""));
      return translated.join(", ");
    },
  },
  {
    accessorKey: "sport_event",
    header: "종목",
  },
  {
    accessorKey: "sport_sub_events",
    header: "유사종목",
    Cell: ({ cell }) => cell.getValue().join(", "),
    muiTableBodyCellProps: {
      sx: {
        whiteSpace: "pre-line",
        width: "150px",
      },
    },
  },
  {
    accessorKey: "instructor_detail.email",
    header: "강사 이메일",
  },
  {
    accessorKey: "instructor_detail.name",
    header: "강사 이름",
  },
  {
    accessorKey: "instructor_detail.corp_name",
    header: "기관 이름",
  },
  {
    accessorKey: "instructor_detail.corp_address",
    header: "주소",
    muiTableBodyCellProps: {
      sx: {
        width: "200px",
        whiteSpace: "pre-line",
      },
    },
  },
  {
    accessorKey: "schedule",
    header: "일정",
    Cell: ({ cell }) => {
      const schedule = getTranslatedPeriod(
        cell.getValue<Array<Record<string, string>>>()
      );
      return (
        <div className="training-schedule-cell">
          {schedule.map((period, index) => (
            <div key={index}>
              {period.date.format("MM/DD")} {period.start_time.format("HH:mm")}{" "}
              - {period.end_time.format("HH:mm")}
            </div>
          ))}
        </div>
      );
    },
  },
  {
    accessorKey: "schedule",
    id: "totalTime",
    header: "총 시간",
    Cell: ({ cell }) => {
      const schedule = getTranslatedPeriod(
        cell.getValue<Array<Record<string, string>>>()
      );

      return <div>{getTotalTime(schedule)}분</div>;
    },
  },
  {
    accessorKey: "registered_students",
    header: "신청인원",
  },
  {
    accessorKey: "student_limit",
    header: "정원",
  },
];

export const InstructorTrainingTableDef = (): MRT_ColumnDef<
  TrainingType,
  any
>[] => {
  const excludeColumns = ["instructor_email", "instructor_name", "corp_name"];

  return basicTrainingTableDef.filter(
    (column) => !excludeColumns.includes(column.accessorKey as string)
  );
};

export const StaffTrainingTableDef = (
  setEditTraining: (id: number) => void,
  deleteTraining: (id: number) => Promise<void>
): MRT_ColumnDef<TrainingType, any>[] => [
  ...basicTrainingTableDef,
  {
    header: "수정",
    Cell: ({ row }) => (
      <button
        onClick={(e) => {
          e.stopPropagation();
          setEditTraining(row.original.id);
        }}
      >
        수정
      </button>
    ),
  },
  {
    header: "삭제",
    Cell: ({ row }) => (
      <button
        className="warning"
        onClick={async (e) => {
          e.stopPropagation();
          if (window.confirm("정말 삭제하시겠습니까?")) {
            await deleteTraining(row.original.id);
            alert("삭제되었습니다.");
          }
        }}
      >
        삭제
      </button>
    ),
  },
];

export const StudentTrainingTableDef = (
  registerTraining: (id: number) => Promise<void>
): MRT_ColumnDef<TrainingType, any>[] => [
  ...basicTrainingTableDef,
  {
    header: "신청",
    Cell: ({ row }) => (
      <button
        onClick={async () => {
          try {
            await registerTraining(row.original.id);
            alert("신청되었습니다.");
          } catch (e: any) {
            if (e.response.status === 400) {
              alert(e.response.data.detail);
            }
          }
        }}
      >
        신청
      </button>
    ),
  },
];

const excludeColumns = [
  "id",
  "student_limit",
  "registered_students",
  "instructor_email",
];
export const StudentRegisteredTrainingTableDef = (
  cancelRegistration: () => Promise<void>
): MRT_ColumnDef<TrainingType, any>[] => [
  ...basicTrainingTableDef.filter(
    (column) => !excludeColumns.includes(column.accessorKey as string)
  ),
  {
    header: "취소",
    Cell: ({ row }) => (
      <button
        style={{ display: "table-cell" }}
        className="warning"
        onClick={async () => {
          if (window.confirm("정말 취소하시겠습니까?")) {
            try {
              await cancelRegistration();
              alert("취소되었습니다.");
            } catch {}
          }
        }}
      >
        취소
      </button>
    ),
  },
];

export const RegisteredStudentTableDef: ColumnDef<Student>[] = [
  {
    accessorKey: "user_code",
    header: "유저코드",
  },
  {
    accessorKey: "name",
    header: "이름",
  },
  {
    accessorKey: "phone",
    header: "전화번호",
  },
  {
    accessorKey: "sport_type",
    header: "종목",
  },
];
